import { removeNamespace } from '../../utils/helpers'

export const ERROR_TYPES = {
  mutations: {
    SET_ERROR: 'error/SET_ERROR'
  },
  actions: {
    setError: 'error/setError'
  }
}

const _types = removeNamespace('error', ERROR_TYPES)

const state = () => ({
  error: null
})

const getters = {}

const mutations = {
  [_types.mutations.SET_ERROR] (state, error) {
    if (!error) {
      state.error = null
      return
    }
    if (!state.error) { // If there's already one set, keep that because it will be the original & most specific
      state.error = error
    }
  }
}

const actions = {
  [_types.actions.setError] ({ commit }, error) {
    this._vm.$appInsights.trackException({ exception: error })
    commit(_types.mutations.SET_ERROR, error)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
